import { App, Component, DefineComponent, VNode, createApp, h, watch } from 'vue'

type Content = ReturnType<typeof h>
interface UseComponentConfig<T = any> {
  component: VNode | Component | Content | DefineComponent
  timeout?: number
  props?: T
  [property: string]: any
}

export const useToast = (config: UseComponentConfig) => {
  const { component, props, timeout } = config
  const div = document.createElement('div')
  let vm: any

  /**
   * 展示组件
   * @param app 组件实例
   * @param time
   */
  const mountComponent = (app: App, timeout = 3) => {
    // 创建文档碎片
    document.body.appendChild(div)
    // 将组件挂载在文档碎片上
    vm = app.mount(div)
    vm.setVisible(true)
    if (timeout < 1) return

    setTimeout(() => {
      vm.setVisible(false)
      setTimeout(() => {
        unmountComponent(app)
      }, 300)
    }, timeout * 1000)
  }

  /**
   * 卸载组件
   * @param app 组件实例
   */
  const unmountComponent = (app: App) => {
    app.unmount()
    document.body.removeChild(div)
  }

  const componentInstance = createApp(component, {
    ...props,
  })

  mountComponent(componentInstance, timeout)

  const close = () => {
    vm.setVisible(false)
    setTimeout(() => {
      unmountComponent(componentInstance)
    }, 300)
  }

  return {
    close,
  }
}
